import type { LayoutClickEvent, LeftItemType, RightItemType } from '@/lib/types/layout';

export const gtagGoogleAnalyticsId = 'G-QZ6ZGLFPQV';
export const gtagGoogleAdsId = 'AW-789114793';
export const gtmId = 'GTM-KV2JZCRW';

export const DATADOG_CONFIG = {
  applicationId: 'cdda0edf-a6b9-4765-8e1d-263deef4902d',
  clientToken: 'pubfbfe8a19c4d45eb72152df453ab07a50',
  service: 'bznav-refund'
};

export const DEFAULT_HEADER_CLICK_EVENTS: Record<LeftItemType | RightItemType, LayoutClickEvent> = {
  back: { name: 'topnav_back' },
  close: { name: 'topnav_close' },
  primaryLogo: { name: 'topnav_logo', attributes: { color: 'primary' } },
  blackLogo: { name: 'topnav_logo', attributes: { color: 'black' } },
  whiteLogo: { name: 'topnav_logo', attributes: { color: 'white' } },
  grayLogo: { name: 'topnav_logo', attributes: { color: 'gray' } },
  exitTextButton: { name: 'topnav_exit' },
  inquiryTextButton: { name: 'topnav_cx', attributes: { button_type: 'text' } },
  inquiryIconButton: { name: 'topnav_cx', attributes: { button_type: 'icon' } },
  shareTextButton: { name: 'topnav_share' },
  moreIconButton: { name: 'topnav_more' }
};
